import { formatDataTest } from '@/common/dataTest/DataTest';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export const ViewSelect = ({ views, activeView, onViewChange }) => {

  const value = views.find(view => view.name === activeView.name);

  return (
    <FormControl sx={{ width: 200 }}>
      <InputLabel>View</InputLabel>
      <Select data-test-id="view-select" value={value} onChange={event => onViewChange(event.target.value)}>
        {views.map(view => <MenuItem data-test-id={formatDataTest('view-select', view.name)} key={view.name} value={view}>{view.name}</MenuItem>)}
      </Select>
    </FormControl>
  )
}